import { render, staticRenderFns } from "./WorkCenterEdit.vue?vue&type=template&id=386c77dc&"
import script from "./WorkCenterEdit.vue?vue&type=script&lang=js&"
export * from "./WorkCenterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports